import React from 'react'
import {Modal, Button} from 'react-bootstrap'

interface DialogProps {
  show: boolean
  title?: string
  body?: React.ReactNode
  onHide: () => void
  footer?: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
  centered?: boolean
  backdrop?: boolean | 'static'
  keyboard?: boolean
  modalClassName?: string
  headerClassname?: string
  bodyClassname?: string
  footerClassname?: string
  closeButtonDisabled?: boolean
}

const Dialog: React.FC<DialogProps> = ({
  show,
  onHide,
  title,
  body,
  footer,
  size = 'lg',
  centered = true,
  backdrop = 'static',
  keyboard = true,
  modalClassName,
  headerClassname,
  bodyClassname,
  footerClassname,
  closeButtonDisabled = true
}) => {
  const modalSize = size === 'md' ? 'lg' : size;
  const customModalClassName = size === 'md' 
    ? `${modalClassName || ''} modal-md`.trim()
    : modalClassName;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={modalSize}
      centered={centered}
      backdrop={backdrop}
      keyboard={keyboard}
      className={customModalClassName}
    >
      <Modal.Header className={headerClassname} closeButton={closeButtonDisabled}>
        {title && <Modal.Title>{title}</Modal.Title>}
      </Modal.Header>

      {body && <Modal.Body className={`${bodyClassname} ${!footer ? 'no-footer' : ''}`}>{body}</Modal.Body>}

      {footer !== undefined && (
        <Modal.Footer className={footer ? footerClassname : ''}>
          {footer || (
            <Button variant='secondary' onClick={onHide}>
              Close
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  )
}

export default Dialog
